import { DATE_SEPARATOR, ISO_DATE_SEPARATOR, MILLISECONDS_PER_DAY, PADDING_CHAR, } from './date.utils.constants.js';
/**
 * Calculates days between two dates
 */
export function daysBetween(date1, date2) {
    const d1 = typeof date1 === 'string' ? new Date(date1) : date1;
    const d2 = typeof date2 === 'string' ? new Date(date2) : date2;
    const diffTime = Math.abs(d2.getTime() - d1.getTime());
    return Math.ceil(diffTime / MILLISECONDS_PER_DAY);
}
/**
 * Formats a date to Chilean format (DD/MM/YYYY)
 */
export function formatToChileanDate(date) {
    const d = typeof date === 'string' ? new Date(date) : date;
    const day = String(d.getDate()).padStart(2, PADDING_CHAR);
    const month = String(d.getMonth() + 1).padStart(2, PADDING_CHAR);
    const year = d.getFullYear();
    return `${day}${DATE_SEPARATOR}${month}${DATE_SEPARATOR}${year}`;
}
/**
 * Formats a date to ISO format (YYYY-MM-DD)
 */
export function formatToISO(date) {
    const d = typeof date === 'string' ? new Date(date) : date;
    return d.toISOString().split(ISO_DATE_SEPARATOR)[0];
}
/**
 * Checks if a date is in the past
 */
export function isPast(date) {
    const d = typeof date === 'string' ? new Date(date) : date;
    return d < new Date();
}
